<template>
  <div>
    Proportion between 0 and 1 of atmosphere molecules that will
                    experience specular reflection when hitting spacecraft
                    instead of experiencing diffuse reflection, hence producing
                    lift. The default value is 0.
  </div>
</template>

<script>
export default {
  name: 'tooltipLiftRatio'
}
</script>
